import axios from 'axios'


export default axios.create({
  baseURL: process.env.ROOT_API + process.env.ADMIN_APP_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin,X-Requested-With,Content-Type,Accept',
    'Access-Control-Allow-Credentials': "true",
	'Access-Control-Allow-Methods': 'POST,GET,OPTIONS,PUT,DELETE' 
  }
})


// WEBPACK FOOTER //
// ./src/plugins/axios.js